import { render, staticRenderFns } from "./serpbook.vue?vue&type=template&id=4532d2ac&"
import script from "./serpbook.ts?vue&type=script&lang=ts&"
export * from "./serpbook.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports